import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ModalsService } from 'app/shared/services/modals.service';
import { HttpService } from 'app/shared/services/http.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ReportsService } from 'app/shared/services/reports.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'report-actions-component',
  templateUrl: './report-actions.component.html',
  styleUrls: ['./report-actions.component.scss'],
})
export class ReportActionsComponent {
  @Input() public data: any;
  public dialogue: string;
  public dialogueSource: string;
  public reportData: any;
  public reportName: string;
  public overrideConfirmed: boolean;
  public overrideReportId: number;
  public subscriptions: Array<any>;
  public postSaveReportObservable: any;
  public postCopyReportObservable: any;
  public postCSVbyEmailObservable: any;
  public postDeleteReportObservable: any;

  constructor(
    public router: Router,
    public modalsService: ModalsService,
    public httpService: HttpService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public reportsService: ReportsService,
    public ga: GoogleAnalyticsService
  ) {
    this.dialogue = '';
    this.dialogueSource = '';
    this.reportData = {};
    this.reportName = '';
    this.overrideConfirmed = false;
    this.subscriptions = [];
  }

  ngOnDestroy() {
    setTimeout(() => {
      if (this.postSaveReportObservable) { this.postSaveReportObservable.unsubscribe(); }
      if (this.postCopyReportObservable) { this.postCopyReportObservable.unsubscribe(); }
      if (this.postCSVbyEmailObservable) { this.postCSVbyEmailObservable.unsubscribe(); }
      if (this.postDeleteReportObservable) { this.postDeleteReportObservable.unsubscribe(); }
    }, 600);
  }

  ngOnChanges($event: any) {
    this.dialogue = $event.data.currentValue.dialogue;
    this.reportData = $event.data.currentValue.reportData;
    setTimeout(() => {
      const reportActionsModal: HTMLElement = document.getElementById('reportActionsModal');
      const inputs: Array<HTMLElement> = !this.sharedService.isEmpty(reportActionsModal)
        ? Array.from(reportActionsModal.getElementsByTagName('input'))
        : [];
      if (inputs.length > 0) {
        inputs[0].focus();
      }
    }, 600);
  }

  validate() {
    const reportName: string = this.reportName;
    const reportNameIsEmpty: boolean = this.sharedService.isEmpty(this.reportName);
    const reportWithTheSameName: any = _.find(this.reportsService.customReports, function (o) {
      return o.reportName.toLowerCase() === reportName.toLowerCase();
    });
    const reportNameInUse: boolean = reportWithTheSameName !== undefined;
    if (reportNameIsEmpty) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('REPORT_NAME_IS_REQUIRED'), 'error');
      return false;
    } else if (
      this.reportsService.getDefaultReportsNames({ lowercase: true }).includes(this.reportName.toLowerCase())
    ) {
      this.sharedService.showFlashMessage(this.dictionaryService.get('REPORT_NAME_ALREADY_IN_USE'), 'error');
      return false;
    } else if (reportNameInUse && !this.overrideConfirmed) {
      this.dialogueSource = this.dialogue;
      this.dialogue = 'OVERRIDE';
      this.overrideReportId = reportWithTheSameName.reportId;
      return false;
    }
    return true;
  }

  save() {
    if (this.validate()) {
      const params: any = { reportName: this.reportName, dimensions: this.reportData.d };
      if (this.reportData.s) {
        params.sorting = this.reportData.s;
      }
      if (this.reportData.f) {
        params.filters = this.reportData.f;
      }
      this.postSaveReportObservable = this.httpService.post('users_management/saveCustomReport', params).subscribe(
        (response) => {
          //let queryParams: any = _.cloneDeep(this.reportData);
          this.sharedService.showFlashMessage(this.dictionaryService.get('REPORT_SAVED_SUCCESSFULLY'), 'success');
          this.modalsService.hideModal();
          this.sharedService.sendMessage('REPORT_SAVED', response);
          /*        queryParams.id = response;
        this.router.navigate(['/reports/new'], { queryParams: queryParams });*/
        },
        (error) => {
          this.sharedService.showErrorFlashMessage();
          this.modalsService.hideModal();
        }
      );
    }
  }

  copy() {
    if (this.validate()) {
      const params: any = {
        reportToCopyId: this.reportData.id,
        newName: this.reportName,
      };
      this.postCopyReportObservable = this.httpService.post('users_management/copyCustomReport', params).subscribe(
        (response) => {
          //let queryParams: any = _.cloneDeep(this.reportData);
          this.sharedService.showFlashMessage(this.dictionaryService.get('REPORT_COPIED_SUCCESSFULLY'), 'success');
          this.modalsService.hideModal();
          this.sharedService.sendMessage('REPORT_COPIED', response);
          //this.router.navigate(['/reports/new'], { queryParams: queryParams });
        },
        (error) => {
          this.sharedService.showErrorFlashMessage();
          this.modalsService.hideModal();
        }
      );
    }
  }

  sendByEmail() {
    const endpointURL: string = this.reportData.endpointURL;
    let errorMessage = '';
    let clientEmails: Array<string> = [];
    this.sharedService.sendMessage('REPORT_BY_EMAIL', this.reportData['isTimeout']);
    delete this.reportData['endpointURL'];
    delete this.reportData['isTimeout'];
    if (this.sharedService.isEmpty(this.reportData.email)) {
      errorMessage = this.dictionaryService.get('EMAIL') + ' ' + this.dictionaryService.get('IS_REQUIRED');
    } else {
      clientEmails = this.reportData.email.split(/[,;\s]/).filter((one: any) => one.trim() != '');
      clientEmails = _.uniq(clientEmails);
      _.forEach(clientEmails, (one: any) => {
        if (!this.sharedService.validateEmail(one)) {
          if (errorMessage === '') {
            errorMessage = this.dictionaryService.get('EMAIL') + ' ' + this.dictionaryService.get('IS_INVALID');
          }
        }
      });
      this.reportData.email = clientEmails.join(',');
      this.postCSVbyEmailObservable = this.httpService
        .post(endpointURL + '/getCSVReportByEmail', this.reportData)
        .subscribe(
          (response: any) => {
            this.sharedService.showFlashMessage(this.dictionaryService.get(response.data), 'success');
          },
          (error: any) => {
            this.sharedService.showFlashMessage(this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'), 'error');
          }
        );
      this.reportsService.isReportSentByEmail = true;
    }
    if (!_.isEmpty(errorMessage)) {
      this.sharedService.showFlashMessage(errorMessage, 'error');
      return false;
    }
    this.modalsService.hideModal();
  }

  delete(reportId: number = null) {
    const params: any = {
      reportId: this.reportData.id,
    };

    const redirectLink: any = _.cloneDeep(this.reportData);
    delete redirectLink.id;

    if (reportId) {
      params.reportId = reportId;
    }
    this.postDeleteReportObservable = this.httpService.post('users_management/deleteCustomReport', params).subscribe(
      (response: any) => {
        delete this.reportData.id;
        if (reportId === null) {
          this.sharedService.showFlashMessage(this.dictionaryService.get('REPORT_DELETED_SUCCESSFULLY'), 'success');
          this.modalsService.hideModal();
          this.sharedService.sendMessage('REPORT_DELETED', this.reportData);
          this.router.navigate(['/reports/new'], { queryParams: redirectLink });
        }
      },
      (error: any) => {
        this.sharedService.showErrorFlashMessage();
        this.modalsService.hideModal();
      }
    );
  }

  confirmOverride() {
    this.overrideConfirmed = true;
    this.delete(this.overrideReportId);
    if (this.dialogueSource === 'SAVE') {
      this.save();
    } else if (this.dialogueSource === 'COPY') {
      this.copy();
    }
  }

  cancelOverride() {
    this.dialogue = this.dialogueSource;
  }

  cancel() {
    this.modalsService.hideModal();
  }
}
